import { render, staticRenderFns } from "./census.vue?vue&type=template&id=e031f286&scoped=true"
import script from "./census.vue?vue&type=script&lang=js"
export * from "./census.vue?vue&type=script&lang=js"
import style0 from "./census.vue?vue&type=style&index=0&id=e031f286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e031f286",
  null
  
)

export default component.exports